import React, { FunctionComponent } from 'react'
import OnBenchPlayer from './OnBenchPlayer'
import { TeamStructureListProps } from './PlayerTypes'
import PlayerSubstitution from './PlayerSubstitution'
import TeamCoach from './TeamCoach'

const TeamStructureList: FunctionComponent<TeamStructureListProps> = props => {
    if (props.type === 'ON_BENCH_PLAYER') return <OnBenchPlayer {...props} />
    if (props.type === 'SUBSTITUTION') return <PlayerSubstitution {...props} />
    return <TeamCoach {...props} />
}

export default TeamStructureList
